import React, { useContext, useEffect, useState } from "react";
import { Grid, CircularProgress } from "@mui/material";
import { ConfigurationContext } from "../../../contexts/Configuration";
import CommonService from "@services/CommonService";
const LoaderWithIcon = () => {
  const { appliedConfiguration, loadingIcon } = useContext(ConfigurationContext);
  const [projectLoadingIcon, setProjectLoadingIcon] = useState(loadingIcon);

  useEffect(() => {
    const icon =
      appliedConfiguration?.coverageFinderConfiguration?.toolLoadingIcon ??
      CommonService.getIcon(appliedConfiguration?.generalSetting?.toolLoadingIcon,appliedConfiguration.clientId);
      setProjectLoadingIcon(icon || loadingIcon || "");
  }, [appliedConfiguration]);

  return (
    <Grid item className="norstella-cf-loaderTable">
      {projectLoadingIcon ? (
        <img
          part="cfDefaultLoadingIcon"
          className="norstella-cf-DefaultLoadingIcon"
          src={projectLoadingIcon}
          alt="Loading Icon"
        />
      ) : (
        <CircularProgress />
      )}
    </Grid>
  );
};

export default LoaderWithIcon;
